var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SSO-btn',{attrs:{"logo":require('@/assets/google_signin_logo.svg'),"provider-name":"Google","loading":_vm.loading},on:{"click":_vm.loginWithGoogle}})}
var staticRenderFns = []

export { render, staticRenderFns }